import React, { useState } from "react";
import { Box, Grid2, Card, CardMedia } from "@mui/material";
import dummySVG from '../../../assets/svg/dummy.svg';
import { isNotEmpty } from "../../../utils/format";
import BlurImg from "../../../components/BlurImg";

function ImageGallery({ prodImgs, sx }) {
  const [selectedImage, setSelectedImage] = useState(isNotEmpty(prodImgs) ? prodImgs[0].fileUrl : dummySVG);
  return (
    <Box sx={{ ...sx }}>
      <Card sx={{ p: 1 }}>
        <CardMedia
          component="img"
          image={selectedImage}
          alt="Main Product Image"
          sx={{
            width: "100%", height: 400, objectFit: "contain"
          }} />
      </Card>

      {/* Thumbnails */}
      <Grid2 container spacing={1.5} alignItems={"center"} sx={{ mt: 2 }}>
        {(prodImgs || []).map((i) => (
          <Grid2 xs={3} key={i?.id}>
            <Card
              sx={{
                cursor: "pointer",
                border: selectedImage === i?.fileUrl ? "2px solid #1976d2" : "none",
              }}
              onClick={() => setSelectedImage(i?.fileUrl)} >
              <Box sx={{
                width: 50, height: 50, borderRadius: 1, m: 0.2, display: 'flex', justifyContent: 'center',
                alignItems: 'center', overflow: 'hidden', // Ensure content doesn't overflow the box
              }}>
                <BlurImg imgUrl={i?.fileUrl} alt={"Product Image"} />
              </Box>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

export default ImageGallery;